import script from "./ChatbotFunctionCall.ce.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotFunctionCall.ce.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./ChatbotFunctionCall.ce.vue?vue&type=style&index=0&id=330abd77&inline&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]]])

export default __exports__